import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleQuickBet } from 'newelements/_Betslip/managers/QuickBetManager/quickBetActions';
import { EQuickBetManagerDispatchActions } from 'newelements/_Betslip/types/quick-bet';
import { useEventbus } from 'newhooks/generic/useEventbus';
import {
  setQuickBetSelectedEventId,
  toggleQuickBetInStore,
  updateQuickBetStake
} from 'store/actions';
import { getQuickBetEnabled } from 'store/selectors/betslip';
import { getIsLoggedIn } from 'store/selectors/user-data';

export const QuickBetManager = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(getIsLoggedIn);
  const isQuickBetEnabled = useSelector(getQuickBetEnabled);

  useEventbus({
    [EQuickBetManagerDispatchActions.TOGGLE_QUICK_BET]: (
      _,
      active?: boolean
    ) => {
      dispatch(toggleQuickBetInStore(active));

      if (!active) {
        dispatch(updateQuickBetStake(0));
        dispatch(setQuickBetSelectedEventId(''));
      }
    }
  });

  useEffect(() => {
    if (!isLoggedIn && isQuickBetEnabled) {
      toggleQuickBet(false);
    }
  }, [isLoggedIn, isQuickBetEnabled]);

  return null;
};
